<template>
  <div class="iv-multiple" :id="item.questionId">
    <p class="iv-fs-16 iv-fc-85 iv-p-t-16 iv-p-b-16 iv-fw-6">
      <span v-if="item.isRequire == 1" style="color: red">* </span>
      [多选题]&nbsp;{{index + 1}}.&nbsp;{{item.questionName}}
    </p>
    <CheckboxGroup v-model="item.userOptions" @on-change="change(item)" vertical>
      <Checkbox v-for="i in item.optionList" :key="i.optionId" :label="i.optionOrder" :disabled="state != 1">
        <div class="iv-label iv-pull-left"><span class="iv-fs-16">{{i.optionOrder}}<span class="iv-p-l-8"></span>{{i.optionInfo}}</span></div>
        <div class="iv-userAnswer iv-pull-left">
          <Edittext :id="id" :item="i" v-if="i.isOtherWrite == 1" />
        </div>
      </Checkbox>
    </CheckboxGroup>
  </div>
</template>
<script>
import Edittext from './edittext.vue'
export default {
  props: ['item', 'index'],
  data () {
    return {
      state: 0
    }
  },
  computed: {
    id () {
      return (this.item.userOptions === null ? '' : this.item.userOptions.toString())
    },
    isRequire () {
      return this.item.isRequire == 1 ? '[必填]' : ''
    }
  },
  created () {
    this.state = this.$route.query.state
  },
  methods: {
    change (item) {
      let isAnswer = this.item.userOptions.length > 0
      this.$emit('change', item, this.index, isAnswer)
    }
  },
  components: {
    Edittext
  }
}
</script>
<style lang="scss" scoped>
  .iv-label{
    line-height:48px;
    vertical-align: middle;
  }
</style>
<style lang="scss">
.iv-multiple{
  border-bottom:1px solid rgba(0,0,0,0.09);
  .ivu-checkbox-inner{
    top: 9px;
  }
  .ivu-checkbox-group-item{
    display: block;
    min-height:48px;
    overflow: hidden;
  }
  .ivu-checkbox{
    float: left;
    margin-right:4px;
    margin-top:7px;
    padding-left: 16px;
    padding-right: 12px;
  }
  .ivu-checkbox-wrapper-checked{
    background: #e6f7ff;
  }
  .iv-text{
    line-height:48px
  }
  .ivu-checkbox-wrapper.ivu-checkbox-group-item{
    margin-top: 8px;
    &::last-child{
      margin-bottom: 0px;
    }
  }
}
</style>